import BgImagePanel from "./bgImagePanel.container";

export default BgImagePanel;
